import { render, staticRenderFns } from "./createNew.vue?vue&type=template&id=0605bbc0"
import script from "./createNew.vue?vue&type=script&lang=js"
export * from "./createNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports